import React, {FormEvent, useState} from 'react';
import {BsFillArrowLeftCircleFill, BsFillArrowRightCircleFill} from 'react-icons/bs';
import {useNavigate} from 'react-router-dom';
import logo from '../../assets/wimpel.webp';
import {usePageMeta} from '../../seo/usePageMeta';
import './login.css';

/** Login form – there is no backend for it yet, it only validates the input. */
const Login = () => {
    usePageMeta({title: 'Login', noindex: true});
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const form = new FormData(event.currentTarget);
        const missingUsername = !form.get('username');
        const missingPassword = !form.get('password');

        if (missingUsername && missingPassword) {
            setErrorMessage('Username and Password are required');
        } else if (missingUsername) {
            setErrorMessage('Username is required');
        } else if (missingPassword) {
            setErrorMessage('Password is required');
        } else {
            setErrorMessage('');
        }
    };

    return (
        <div className="login-page-container">
            <div className="login-page-back">
                <BsFillArrowLeftCircleFill onClick={() => navigate(-1)} title="Zurück"/>
            </div>

            <div className="login-page-menu-container">
                <div className="login-page-logo">
                    <img src={logo} alt="VCH Logo"/>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="login-page-item">
                        <label htmlFor="inputUsername">Username</label>
                        <input type="text" id="inputUsername" name="username" placeholder="name" autoComplete="username"/>
                    </div>
                    <div className="login-page-item">
                        <label htmlFor="inputPassword">Password</label>
                        <input type="password" id="inputPassword" name="password" placeholder="password"
                               autoComplete="current-password"/>
                    </div>
                    <div className="login-page-submit">
                        <button type="submit" className="login-page-submit-button" aria-label="Anmelden">
                            <BsFillArrowRightCircleFill/>
                        </button>
                    </div>
                    <div className="login-page-error">{errorMessage}</div>
                </form>
            </div>
        </div>
    );
};

export default Login;
